import { useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginPage from "../../pages/login/LoginPage";
import { auth } from "../../matabase";
import { signInWithEmailAndPassword } from "firebase/auth";

const Login = () => {
  const [inputs, setInputs] = useState({
    email: "",
    password: "",
  });
  const [err, setErr] = useState(null);
  const [load, setLoad] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) => {
    setInputs((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const hanleSubmit = async (e) => {
    setLoad(true);
    e.preventDefault();
    console.log(inputs);
    try {
      const res = await signInWithEmailAndPassword(
        auth,
        inputs.email,
        inputs.password
      );
      console.log("sign in successful ", res);
      navigate("/");
    } catch (error) {
      console.log(error);
      setErr("Wrong email or password");
    }
    setLoad(false);
  };

  return (
    <div>
      {load ? (
        <p className="load-err">Loading...</p>
      ) : (
        <LoginPage
          inputs={inputs}
          handleChange={handleChange}
          hanleSubmit={hanleSubmit}
          err={err}
        />
      )}
    </div>
  );
};

export default Login;
